
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import api from '~/api/' // server
import SearchDate from '~/components/Common/UI/Search/SearchDate'
import SearchPeriod from '~/components/Common/UI/Search/SearchPeriod'
import List from '~/components/Common/UI/List_Board'
import Paging from '~/components/Common/UI/Paging'
import { getFileType } from '~/constants/NewsTypeURI'
import { arrSplit } from '~/utils/index'

export default {
    name: 'Board',

    components: {
        SearchPeriod,
        SearchDate,
        List,
        Paging,
    },

    props: {
        pageTitle: {
            type: String,
        },
        newsType: String,
        pageSize: {
            type: Number,
            default: 10,
        },
        keydata: Object,
        search: String,
    },

    data() {
        return {
            reqSize: 50,
            list: [],
            pageRowCount: 10,
            isDateSetAll : false, // 기간검색시 최대 기간 2년이 아니라 전체로 검색가능
        }
    },

    computed: {
        ...mapState('paging', [
            'curPage',
            'blockLocation',
            'nextKey',
            'prevKey',
        ]),
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
        ...mapGetters('search', ['getSearch']),
        },

    watch: {
        getSearch() {
            this.getList()
        },
    },

    created() {
        /* 
            220318 meej reset paging 추가
        */
        this.RESET_STORE()
        // MENU_MOBILENEWS에 대해서만 페이징 규칙 다르게 적용
        // 22.04.13 suye 모바일주식신문 한페이지당 목록 5개 -> 20개 reqSize 25 -> 100
        if (this.newsType === 'MENU_MOBILENEWS') {
            this.reqSize = 100
            this.pageRowCount = 20 
        }
        
        /* 
            220510 meej 테마 브리핑, 인포스탁 인사이트는 2년기간 제한 없이 전체를 보여주어야함
         */
        if(this.newsType === 'MENU_DAILY_THEME_BRIEFING' || this.newsType === 'MARKET_INFOSTCOK_INSIGHT'){
            // 최대기간 : 전체
            this.isDateSetAll = true
        } else{
            // 최대기간 : 2년
            this.isDateSetAll = false
        }
        this.getList()
    },
    /* 20210521 shb 추가 */
    beforeDestroy() {
        // 화면이 전환or종료 될때 store 초기화
        this.RESET_STORE()
    },
    methods: {
        ...mapMutations('paging', [
            'SET_PAGING',
            'SET_PREV_KEY',
            'SET_NEXT',
            'SET_PREV',
            'RESET_STORE',
        ]),
        ...mapActions('paper', ['GET_LIST']),
        ...mapActions('board', ['GET_BASE64_CONTENT']),

        async getList(Key) {
            
            const params = {
                menuType: this.newsType,
                count: this.reqSize,
                ...this.getSearch,
            }
            if (Key) {
                params.nextKey = Key
            } 
            
            await api.getBoardList(params)
            .then((res)=>{ 
                if (res.success) {
                    if (res.data != null && res.data.items != null && res.data.items.length > 0) {
                        this.list = arrSplit(res.data.items, this.pageRowCount)
                        this.SET_PAGING({
                            count: this.list.length,
                            /* 
                                220512 meej 페이징 오류 수정 block: this.pageRowCount -> 5
                            */
                            block: 5,
                            nextKey: res.data.nextKey,
                        })
                    } else {
                        /* 
                            220411 meej paging 초기화 추가
                        */
                        this.list = []
                        this.SET_PAGING({
                            count: 1,
                            block: 0,
                            nextKey: null,
                        })
                    } 
                }else{
                    alert(res.message)
                    this.list = []
                    this.SET_PAGING({
                        count: 1,
                        block: 0,
                        nextKey: null,
                    })   
                }
            })
            .catch((err)=>{
                console.log("newspaper_page board -> ", err)
                alert(err)
                this.list = []
                this.SET_PAGING({
                    count: 1,
                    block: 0,
                    nextKey: null,
                })
            })
        },

        onClickItem(values) {
            // console.log('values', values)
            // console.log('MEMBER_INFO: ', this.MEMBER_INFO.type)

            const currentPath = this.$router.currentRoute.path

            switch (getFileType(values.newsType1)) {
                case 'pdf': {
                    const routeData = this.$router.resolve({
                        name: `/pdfviewer?newstype=${values.newsType1}&id=${values.id}`,
                    })

                    window.open(
                        routeData.location.name,
                        'pdfviewer',
                        'width=940px,height=1000,resizable=yes',
                    )

                    break
                }

                case 'popup': {
                    let routeData
                    let timeFlag
                    if (this.newsType === 'MENU_MOBILENEWS') {
                        // 2022.04 suki - 주식신문 url이 너무 길어서 newsid, memberid 를 관리하는 테이블 추가(MPaperManage)
                        // news id 와 index 로 path 를 만들고
                        // 맨앞에 m , h 로 member path 인지 homepage path 인지 구분한다.
                        // h 로 시작하면 session 으로 체크하고 뒤에 붙는 건 newsid 만 붙인다.
                        // m 로 시작하면 newsid 뒤 index 를 분리하고 
                        // MPaperManage 테이블에서 newsid 와 index 로 조회해서 처리 한다.
                        const newspaperAPPLocation = process.env.NEWSPAPER_APP
                        const testRouteData = this.$router.resolve({
                            name: `${newspaperAPPLocation}/h${values.id}`,
                        })
                        const handle = window.open(
                            testRouteData.location.name,
                            'MobileStockPaper',
                            'width=900px,height=850,scrollbars=1,resizable=yes,target=_blank'
                        )
                        if(!handle){
                            alert(handle)
                        }
                    }
                    break
                }
                default: {
                    // 새창
                    const routeData = {
                        path: `${currentPath}/${values.id}`,
                        query: { newsType: values.newsType1 },
                    }
                    this.$router.push(routeData)
                }
            }
        },
        /* 20210521 shb paging 관련  */
        // onChangePage() {
        // @clickPage="onChangePage"
        // },
        onClickNext() {
            this.SET_PREV_KEY(this.list[0][0].createTime)
            this.SET_NEXT()
            this.getList(this.nextKey)
        },
        onClickPrev() {
            this.SET_PREV()
            this.getList(this.prevKey)
        },
    },
}
